import { render } from "./info_pengerjaan_salah_benar.vue?vue&type=template&id=6887692a&scoped=true"
import script from "./info_pengerjaan_salah_benar.vue?vue&type=script&lang=js"
export * from "./info_pengerjaan_salah_benar.vue?vue&type=script&lang=js"

import "./info_pengerjaan_salah_benar.vue?vue&type=style&index=0&id=6887692a&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6887692a"]])

export default __exports__